import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingSuccess, loadingFailure } from './status'
import mergePayload from './utils/mergePayload'
import Actions from './utils/actions'
import toQueryString from './utils/toQueryString'

const RESOURCE_NAME = 'volumeGd'

const endpoint = (action, id) => {
  switch (action) {
    case Actions.INDEX:
    case Actions.CREATE:
      return `/acl/contratos_gd/${id}/volumes_gd`

    case Actions.SHOW:
    case Actions.UPDATE:
    case Actions.DESTROY:
      return `/acl/volumes_gd/${id}`

    default:
      return ''
  }
}

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingVolumeGdSuccess(resource))
  return Promise.resolve(resource)
}

const resolveDestroy = (dispatch, id) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(destroyingVolumeGdSuccess(id))
  return Promise.resolve()
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_VOLUME_GD_SUCCESS = 'LOADING_VOLUME_GD_SUCCESS'
export function loadingVolumeGdSuccess(volumeGd) {
  return {
    type: LOADING_VOLUME_GD_SUCCESS,
    volumeGd,
  }
}

export const DESTROYING_VOLUME_GD_SUCCESS = 'DESTROYING_VOLUME_GD_SUCCESS'
export function destroyingVolumeGdSuccess(volumeGdId) {
  return {
    type: DESTROYING_VOLUME_GD_SUCCESS,
    volumeGdId,
  }
}

export function fetchMultipleVolumeGd(parentId, params = {}) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(
      endpoint(Actions.INDEX, parentId) + toQueryString(params)
    ).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function fetchVolumeGd(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.SHOW, id)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function createVolumeGd(parentId, volumeGd) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.CREATE, parentId), 'POST', volumeGd).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function updateVolumeGd(id, volumeGd) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.UPDATE, id), 'PUT', volumeGd).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function destroyVolumeGd(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return await API.call(endpoint(Actions.DESTROY, id), 'DELETE').then(
      () => resolveDestroy(dispatch, id),
      error => reject(dispatch, error)
    )
  }
}

const volumeGd = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_VOLUME_GD_SUCCESS: {
      const { volumeGd: payload } = action
      return mergePayload(state, payload)
    }

    case DESTROYING_VOLUME_GD_SUCCESS:
      return state.delete(action.volumeGdId.toString())

    default:
      return state
  }
}

export default volumeGd
